/*
 * Copyright 2025 Sisters Inspire Sdn Bhd
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Program access roles — shared across finsys-api and finhub-adonisjs.
 * Values must match the database enum column in the `programaccess` table.
 */
export enum Role {
  ADMIN = 'Admin',
  BORROWER_AGENT = 'Borrower Agent',
  LENDER_AGENT = 'Lender Agent',
}
